import { FC } from 'react';
import cn from 'classnames';
import styles from './index.module.less';
import { SiteLogo } from '@pro/common/SiteLogo';
import { FooterNav } from '@app/common/PageFooter/FooterNav';
import { FooterFollow } from '@app/common/PageFooter/FooterFollow';
import { FooterHelp } from '@app/common/PageFooter/FooterHelp';
import { FooterCopy } from '@app/common/PageFooter/FooterCopy';
import { ContactList } from '@pro/common/ContactList';

type IPageFooterProps = {};

export const PageFooter: FC<IPageFooterProps> = props => {
    const {} = props;
    return (
        <>
            <div className={cn(styles.footer, 'wrapper py-64 text-medium')}>
                <div className={'mb-128 flex flex-wrap'}>
                    <div className={styles['col-left']}><FooterNav/></div>
                    <div className={styles['col-center']}>
                        <h3 className={cn('mb-24', styles['contact-title'])}>CONTACT</h3>
                        <ContactList className={styles['contact-list']}/>
                    </div>
                    <div className={cn(styles['col-right'], styles['col-follow'])}><FooterFollow/></div>
                </div>

                <div className={'flex flex-wrap'}>
                    <div className={styles['col-left']}><SiteLogo type={'darkIcon'} size={68}/></div>
                    <div className={cn(styles['col-center'], styles['col-copy'])}><FooterCopy/></div>
                    <div className={cn(styles['col-right'], styles['col-help'])}><FooterHelp/></div>
                </div>
            </div>
            <div className={styles['footer-logo']}>
                <SiteLogo type={'lightText'} fixed={false}/>
            </div>
        </>
    )
};
